import { z } from "zod/mini"

export const EmptyContentType = "EmptyContent" as const

export const EmptyContentSchema = z.object({
	type: z.string(),
	__TYPE__: z.literal(EmptyContentType),
})

export type EmptyContent = z.infer<typeof EmptyContentSchema>
